import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class LevelGenericTask extends AbstractRequestTask {

    constructor(params) {
        super();
        this.params = params
    }


    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        
        return `${http}${url}/services/cms/level`;
    }

    getParams() {

        const params = super.getParams();
        return Object.assign({}, params, this.params);
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }
}

export default LevelGenericTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/cms/LevelGeneric.js